<!-- -------------------------------------------------------------- -->
<!-- Add Event -->
<!-- -------------------------------------------------------------- -->

<div mat-dialog-content>
  <div class="d-flex align-items-center justify-content-between m-b-16">
    <h4 class="f-s-16 f-w-600 m-b-16">Add Event</h4>
    <button
      mat-icon-button
      mat-dialog-close
      class="d-flex justify-content-center"
    >
      <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
  </div>

  <form name="eventForm" [formGroup]="eventForm" class="event-form">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            name="title"
            formControlName="title"
            placeholder="Add Title"
            required
          />
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            placeholder="Change Color"
            type="color"
            (colorPickerChange)="
              eventForm.patchValue({
                color: { primary: event().color.primary }
              })
            "
          />
        </mat-form-field>
      </div>

      <div class="col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [matDatepicker]="startDateDP"
            placeholder="Start Date"
            name="startDate"
            formControlName="start"
          />
          <mat-datepicker-toggle
            class="add-event-date"
            matSuffix
            [for]="startDateDP"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDateDP></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-sm-6">
        <mat-form-field appearance="outline" class="w-100">
          <input
            matInput
            [matDatepicker]="endDateDP"
            placeholder="End Date"
            name="endDate"
            formControlName="end"
          />
          <mat-datepicker-toggle
            class="add-event-date"
            matSuffix
            [for]="endDateDP"
          ></mat-datepicker-toggle>
          <mat-datepicker #endDateDP></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="d-flex align-items-center gap-12">
      <button
        mat-flat-button
        color="primary"
        (click)="dialogRef.close({ action: 'save', event: eventForm.value })"
        [disabled]="eventForm.invalid"
        aria-label="SAVE"
      >
        Save
      </button>
      <button mat-button mat-dialog-close class="bg-error text-white">
        Cancel
      </button>
    </div>
  </form>
</div>
